<template>
  <div class="account_content">
    <div class="account_content_header">
      <div class="account_content_header_title">
        <span>Data Analysis</span>
        <div>
          <el-button type="text">Re select data</el-button>
          <el-button
            type="text"
            :disabled="selectList.length > 1 || selectList.length == 0"
            >Search Leads</el-button
          >
        </div>
      </div>
      <div class="account_content_header_tab">
        <div class="account_content_header_tab_item" @click="linkToAnalysis">
          Industry Analysis
        </div>
        <div class="account_content_header_tab_item active">
          Enterprise Analysis
        </div>
      </div>
    </div>
    <div class="account_content_wrapper">
      <div class="rating_tips">
        <span> Rating Score: 1 = Worst ; 6 = Best</span>
        <span>
          <div class="rating_tips_block" style="background: #ec1a1a" />
          1
        </span>
        <span>
          <div class="rating_tips_block" style="background: #ff8200" />
          2
        </span>
        <span>
          <div class="rating_tips_block" style="background: #ffc702" />
          3
        </span>
        <span>
          <div class="rating_tips_block" style="background: #b2d900" />
          4
        </span>
        <span>
          <div class="rating_tips_block" style="background: #3fb92f" />
          5
        </span>
        <span>
          <div class="rating_tips_block" style="background: #139902" />
          6
        </span>
      </div>
      <el-table
        class="risk_table merge_border_table"
        :data="tableData"
        border
        height="100%"
        ref="tableRef"
        @selection-change="onSelectionChange"
      >
        <el-table-column
          v-if="isOpenSlct"
          :resizable="false"
          type="selection"
          reserve-selection
          align="center"
          class-name="table_check_row"
          width="40"
        />
        <el-table-column
          prop="name"
          align="left"
          min-width="150"
          label="Company Name"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="flex_center_start_box">
              <span class="link_hover_text" @click="goDetail(scope.row)">
                {{ scope.row.name }}</span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="date"
          align="center"
          label="Update Date"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="industry"
          align="center"
          label="Industry"
          min-width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="Subject Company"
          align="center"
          show-overflow-tooltip
        >
          <el-table-column
            prop="profitability"
            align="center"
            label="Profitability"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.profitability) }"
              >
                {{ scope.row.profitability }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="operation"
            align="center"
            label="Operation"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.operation) }"
              >
                {{ scope.row.operation }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="liquidity"
            align="center"
            label="Liquidity"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.liquidity) }"
              >
                {{ scope.row.liquidity }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="structure"
            align="center"
            label="Structure"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.structure) }"
              >
                {{ scope.row.structure }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Industry Norm" align="center">
          <el-table-column
            prop="profitability2"
            align="center"
            label="Profitability"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.profitability2) }"
              >
                {{ scope.row.profitability2 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="operation2"
            align="center"
            label="Operation"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.operation2) }"
              >
                {{ scope.row.operation2 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="liquidity2"
            align="center"
            label="Liquidity"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.liquidity2) }"
              >
                {{ scope.row.liquidity2 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="structure2"
            align="center"
            label="Structure"
            min-width="85"
          >
            <template slot-scope="scope">
              <div
                class="rating_block"
                :style="{ background: getColor(scope.row.structure2) }"
              >
                {{ scope.row.structure2 }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <Page
          keyword="Enterprise Analysis"
          :fontColor="'#1290C9'"
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import Page from "@/views/newLayout/page.vue";
import { mixins1 } from "@/mixins/index";
export default {
  components: {
    Page,
  },
  mixins: [mixins1],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 1000,
      searchParams: {
        name: "",
        date: "",
        country: "",
        credit: "",
      },
      isOpenSlct: false,
      selectList: [],
      selectOptions: [
        { value: "option1", label: "Option 1" },
        { value: "option2", label: "Option 2" },
        { value: "option3", label: "Option 3" },
      ],
      tableData: [
        {
          aaaId: "1",
          name: "Apple Inc.",
          date: "2024",
          industry: "Camping grounds",
          profitability: 4,
          operation: 4,
          liquidity: 4,
          structure: 4,
          profitability2: 5,
          operation2: 5,
          liquidity2: 5,
          structure2: 5,
        },
        {
          aaaId: "2",
          name: "Apple Inc.",
          date: "2024",
          industry: "Camping grounds Camping grounds",
          profitability: 5,
          operation: 5,
          liquidity: 5,
          structure: 5,
          profitability2: 3,
          operation2: 3,
          liquidity2: 3,
          structure2: 3,
        },
        {
          aaaId: "3",
          name: "Apple Inc.",
          date: "2024",
          industry: "Camping grounds Camping grounds",
          profitability: 6,
          operation: 6,
          liquidity: 6,
          structure: 6,
          profitability2: 5,
          operation2: 5,
          liquidity2: 5,
          structure2: 5,
        },
        {
          aaaId: "4",
          name: "Apple Inc.",
          date: "2024",
          industry: "Camping grounds Camping grounds",
          profitability: 1,
          operation: 1,
          liquidity: 1,
          structure: 1,
          profitability2: 2,
          operation2: 2,
          liquidity2: 2,
          structure2: 2,
        },
      ],
      industryObservationData: [
        {
          aaaId: 1,
          comparison: "Years in Business",
          average: "3",
          mean: "3",
          max: "3",
          min: "3",
        },
        {
          aaaId: 2,
          comparison: "Revenue",
          average: "2,308",
          mean: "2,308",
          max: "2,308",
          min: "2,308",
        },
        {
          aaaId: 3,
          comparison: "Net Earning",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 4,
          comparison: "Total Assets",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 5,
          comparison: "Total Liability",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 6,
          comparison: "Total Net Earning",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 7,
          comparison: "Total Operating Cost",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 8,
          comparison: "Return on equity (%)",
          average: "53.28%",
          mean: "53.28%",
          max: "53.28%",
          min: "53.28%",
        },
        {
          aaaId: 9,
          comparison: "Return on Assets (ROA)",
          average: "104.31%",
          mean: "104.31%",
          max: "104.31%",
          min: "104.31%",
        },
        {
          aaaId: 10,
          comparison: "Profit margin (%)",
          average: "89.78%",
          mean: "89.78%",
          max: "89.78%",
          min: "89.78%",
        },
        {
          aaaId: 11,
          comparison: "Gross margin (%)",
          average: "48.91%",
          mean: "48.91%",
          max: "48.91%",
          min: "48.91%",
        },
        {
          aaaId: 12,
          comparison: "Asset turnover (x)",
          average: "225.76%",
          mean: "225.76%",
          max: "225.76%",
          min: "225.76%",
        },
      ],
    };
  },
  computed: {
    getColor() {
      return (value) => {
        switch (value) {
          case 1:
            return "#EC1A1A";
          case 2:
            return "#FF8200";
          case 3:
            return "#FFC702";
          case 4:
            return "#B2D900";
          case 5:
            return "#3FB92F";
          case 6:
            return "#139902";
          default:
            return "#666666";
        }
      };
    },
  },
  beforeDestroy() {},
  watch: {
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    // 能力表现单元格合并
    arraySpanMethod({ row, column, rowIndex, columnIndex }, list) {
      if (columnIndex === 0) {
        let prevRow = list[rowIndex - 1];
        let nextRow = list[rowIndex + 1];

        if (prevRow && row.performance == prevRow.performance) {
          //当有上一条数据，并且和当前类型相同

          return {
            rowspan: 0,
          };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow.performance == row.performance) {
            //当有下一条数据并且和当前类型相同时,获取新的下一条
            countRowspan++;
            nextRow = list[rowIndex + countRowspan];
            console.log(row, prevRow, nextRow);
          }
          return {
            rowspan: countRowspan,
            colspan: 1,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }; // 默认不合并其他列
    },
    rowClassName({ row, rowIndex }, list) {
      // 获取能力表现合并行每一组对应的行号
      const data = list || [];
      // 第一行一定是新组
      if (rowIndex === 0) {
        return "line_cell_item";
      }
      const current = data[rowIndex];
      const prev = data[rowIndex - 1];
      // 和上一行不同，说明是新组第一行
      if (prev && current.performance !== prev.performance) {
        return "line_cell_item";
      }

      return "";
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    onChangePage(pagParm) {
      this.currentPage = pagParm.page;
      this.pageSize = pagParm.pageSize;
      // this.getPageList();
    },

    linkToAnalysis() {
      this.$router.push({
        path: "/account/industryAnalysis",
        // query: {
        //   id3a: this.$route.query.id3a,
        //   keyword: this.$route.query.keyword,
        //   selectKey: this.$route.query.selectKey,
        //   type: String(index),
        // },
      });
    },
  },
  mounted() {
    // this.$store.dispatch("app/toggleMenu", false);
    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: true,
    });

    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: true,
    });
  },
};
</script>
<style scoped>
.account_content {
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.account_content_header {
  height: 124px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 20px;
}
.account_content_wrapper {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.account_content_header_title {
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.account_content_header_title span {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 34px;
  text-align: left;
}
.account_content_header_title .el-button {
  color: #1290c9;
  margin-left: 10px;
}

.account_content_header_title .el-button.is-disabled {
  color: #999999;
}
.account_content_header_tab {
  width: fit-content;
  margin: 10px auto 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 4px;
}
.account_content_header_tab_item {
  padding: 9px 20px;
  height: 40px;
  font-size: 18px;
  color: #1a2332;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}
.account_content_header_tab_item.active {
  font-family: Arial Bold;
  background: #ffffff;
  border-radius: 4px;
}
.rating_tips {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 20px;
}
.rating_tips span {
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  display: flex;
  gap: 10px;
  align-items: center;
}
.rating_tips span:first-child {
  margin-right: 10px;
}
.rating_tips_block {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}

.merge_border_table.el-table >>> .el-table__cell {
  border-right: 1px solid #cccccc;
}
.merge_border_table.el-table >>> .el-table__cell {
  border-color: #cccccc;
}
.merge_border_table.el-table >>> tr td:nth-child(1),
.merge_border_table.el-table >>> tr td:nth-child(2),
.merge_border_table.el-table >>> tr th:nth-child(1),
.merge_border_table.el-table >>> tr th:nth-child(2) {
  border-right: none;
}
.rating_block {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  border-radius: 4px;
  font-size: 18px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  font-style: normal;
}
.link_hover_text {
  color: #1290c9;
}
.risk_table
  .el-table__body
  tr:hover
  > td.el-table__cell:not(.el-table__expanded-cell)
  .link_hover_text {
  color: #1290c9;
  text-decoration: underline;
}
@media (max-width: 1920px) {
  .account_content {
    gap: 8px;
  }
  .account_content_header {
    height: 95px;
    padding: 14px;
  }
  .account_content_wrapper {
    padding: 14px 22px;
  }
  .account_content_header_title {
    padding-left: 8px;
  }
  .account_content_header_title span {
    font-size: 18px;
    line-height: 26px;
  }
  .account_content_header_tab {
    margin: 8px auto 14px;
    height: 36px;
    padding: 5px 14px;
  }
  .account_content_header_tab_item {
    padding: 7px 14px;
    height: 30px;
    font-size: 14px;
  }
  .rating_tips {
    gap: 14px;
    margin-bottom: 14px;
  }
  .rating_tips span {
    font-size: 14px;
    line-height: 18px;
    gap: 8px;
  }
  .rating_tips span:first-child {
    margin-right: 8px;
  }
  .rating_tips_block {
    width: 14px;
    height: 14px;
  }
  .rating_block {
    width: 22px;
    height: 22px;
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
